module.exports = __webpack_public_path__ + "img/logo.13e295d2.png";